export const companyIntegrationsProjects = (state) => state.service.companyIntegrationsProjects;
